module.exports = __webpack_public_path__ + "static/img/sydney-uni.b46536f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sydney/sydney-uni.jpg
// module id = 272
// module chunks = 1